import LoadingStatus from 'enums/loadingStatus';
import { createSlice } from '@reduxjs/toolkit';
import initialState from './initialState';

const pageDefaultValue = 1;
const pageSizeDefaultValue = 20;

const articleSearchParametersSlice = createSlice({
  name: 'articleSearchParameters',
  initialState,
  reducers: {
    updateSearchTermParameter: (state, action) => {
      // rule for new searches go to first page with default page size
      state.page = pageDefaultValue;
      state.pageSize = pageSizeDefaultValue;
      state.searchTerm = action.payload;
    },
    updateCategoryNamesParameter: (state, action) => {
      // rule for new searches go to fisrt page with default page size
      state.page = pageDefaultValue;
      state.pageSize = pageSizeDefaultValue;
      state.categoryNames = action.payload;
    },
    updatePageSizeParameter: (state, action) => {
      // rule if the page size change the page should be 1
      state.page = pageDefaultValue;
      state.pageSize = action.payload;
    },
    updatePageParameter: (state, action) => {
      state.page = action.payload;
    },
    fetchArticles: (state) => {
      state.fetchingArticlesStatus = LoadingStatus.Loading;
    },
    fetchArticlesSuccess: (state) => {
      state.fetchingArticlesStatus = LoadingStatus.Succeeded;
    },
    fetchArticlesError: (state) => {
      state.fetchingArticlesStatus = LoadingStatus.Failed;
    },
    fetchArticlesCounts: (state) => {
      state.fetchingArticlesCountsStatus = LoadingStatus.Loading;
    },
    fetchArticlesCountsSuccess: (state) => {
      state.fetchingArticlesCountsStatus = LoadingStatus.Succeeded;
    },
    fetchArticlesCountsError: (state) => {
      state.fetchingArticlesCountsStatus = LoadingStatus.Failed;
    }
  },
});

export default articleSearchParametersSlice;